import * as React from "react"
const SidebarThreadIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 14 }
        height={ 14 }
        fill="var(--text-white)"
        viewBox="0 0 14 13"
        { ...props }
    >
        <path d="M11.795.005c.336 0 .62.12.85.36.24.23.36.514.36.85v7.2c0 .336-.12.62-.36.85-.23.23-.514.345-.85.345H3.4L.995 12.015v-10.8c0-.336.115-.62.346-.85.24-.24.528-.36.864-.36h9.59Zm-9.59 1.21v7.891l.691-.691h8.9v-7.2H2.204Zm1.195 1.8h7.2V4.21H3.4V3.015Zm0 2.39h5.4v1.21H3.4v-1.21Z" />
    </svg>
)
export default SidebarThreadIcon;